/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Status_Failed_RetryInputs */



/**
* | output |
* | --- |
* | "Saving the winner's deck again, or publishing to VEKN again, retries." |
*
* @param {Twda_Status_Failed_RetryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_status_failed_retry = /** @type {((inputs?: Twda_Status_Failed_RetryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Status_Failed_RetryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer à nouveau le deck du vainqueur, ou publier à nouveau sur VEKN, renvoie le deck au TWDA.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar de nuevo el mazo del ganador, o enviar de nuevo a VEKN, reenvía el mazo al TWDA.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salvar o deck do vencedor novamente, ou enviar novamente para a VEKN, reenvia o deck para o TWDA.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvare di nuovo il mazzo del vincitore, o inviare di nuovo al VEKN, reinvia il mazzo al TWDA.")
	return /** @type {LocalizedString} */ ("Saving the winner's deck again, or publishing to VEKN again, retries.")
});